import { Box, Typography } from '@mui/material';
import { redemptionVoucherPreviewSrc, xpCoinSrc } from '../../assets/bazzar';
import { BAZAAR_DIALOG_INNER_BG, BAZAAR_DIALOG_INNER_SHADOW } from './bazaarDialogShared';
import AccessCouponButton from './AccessCouponButton';

const PANEL_MAX_WIDTH = 390;

const headerFallbackGradient = {
  cinema: 'linear-gradient(145deg, #0b0205, #2e1500 45%, #0b0205)',
  food: 'linear-gradient(145deg, #4f1300, #d83a00 45%, #f0b135)',
  fashion: 'linear-gradient(145deg, #123d58, #ffffff 48%, #e6006e)',
};

/** Figma 10040:5503 — coupon info detail panel */
export default function CouponDetailPanel({ coupon, onAccessCoupon }) {
  const imageUrl = coupon?.imageUrl;
  const imageTone = coupon?.imageTone || 'fashion';
  const headerGradient = headerFallbackGradient[imageTone] || headerFallbackGradient.fashion;

  return (
    <Box sx={{ width: '100%', maxWidth: PANEL_MAX_WIDTH, mx: 'auto' }}>
      <Box
        sx={{
          borderRadius: '35px',
          border: '1px solid #d6a7ff',
          background: 'linear-gradient(180deg, #8f51fb 0%, #5c1ec8 34.483%)',
          boxShadow: '0 0 16px 6px rgba(183, 89, 255, 0.35)',
          p: '5px',
        }}
      >
        <Box
          sx={{
            borderRadius: '32px',
            background: BAZAAR_DIALOG_INNER_BG,
            boxShadow: BAZAAR_DIALOG_INNER_SHADOW,
            overflow: 'hidden',
            px: 2.5,
            pt: 2.5,
            pb: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: 120,
              mb: 2,
              position: 'relative',
            }}
          >
            {imageUrl ? (
              <Box
                component="img"
                src={imageUrl}
                alt={coupon?.brand || 'Voucher'}
                sx={{ maxWidth: 139, maxHeight: 82, objectFit: 'contain', display: 'block' }}
              />
            ) : (
              <Box
                sx={{
                  width: 139,
                  height: 82,
                  borderRadius: 1,
                  overflow: 'hidden',
                  background: headerGradient,
                  display: 'grid',
                  placeItems: 'center',
                }}
              >
                <Box
                  component="img"
                  src={redemptionVoucherPreviewSrc}
                  alt=""
                  sx={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.9 }}
                />
              </Box>
            )}
          </Box>

          <Typography
            sx={{
              color: '#fff',
              fontWeight: 600,
              fontSize: 16,
              lineHeight: '24px',
              letterSpacing: '0.8px',
              textAlign: 'center',
              mb: 1.5,
            }}
          >
            {coupon?.title}
          </Typography>

          {coupon?.subtitle ? (
            <Typography
              sx={{
                color: '#fff',
                fontWeight: 500,
                fontSize: 14,
                lineHeight: '20px',
                letterSpacing: '0.5px',
                textAlign: 'center',
                mb: 1.5,
              }}
            >
              {coupon.subtitle}
            </Typography>
          ) : null}

          {coupon?.validTill ? (
            <Typography
              sx={{
                color: 'rgba(255, 255, 255, 0.7)',
                fontWeight: 400,
                fontSize: 12,
                lineHeight: '20px',
                letterSpacing: '0.8px',
                textAlign: 'center',
                mb: 2,
              }}
            >
              {coupon.validTill}
            </Typography>
          ) : null}

          <AccessCouponButton
            onClick={() => onAccessCoupon?.(coupon)}
            disabled={coupon?.canAccessCoupon === false}
            maxWidth={350}
          />

          {(coupon?.redeemedXp || coupon?.redeemedAt) && (
            <Box
              sx={{
                mt: 2,
                pt: 1.5,
                borderTop: '1px solid rgba(255, 255, 255, 0.12)',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  mb: 0.75,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                  <Box
                    component="img"
                    src={xpCoinSrc}
                    alt=""
                    sx={{ width: 21, height: 21, display: 'block' }}
                  />
                  <Typography sx={{ color: '#fff', fontSize: 14, fontWeight: 500, lineHeight: '20px' }}>
                    Redeemed:
                  </Typography>
                </Box>
                {coupon.redeemedXp ? (
                  <Typography sx={{ color: '#fff', fontSize: 14, fontWeight: 500, lineHeight: '20px' }}>
                    - {coupon.redeemedXp}
                  </Typography>
                ) : null}
              </Box>
              {coupon.redeemedAt ? (
                <Typography
                  sx={{
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: '20px',
                    textAlign: 'center',
                  }}
                >
                  {coupon.redeemedAt}
                </Typography>
              ) : null}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
